<template>
  <q-dialog :model-value="modelValue" maximized @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="usp-dialog">

      <!-- Шапка -->
      <q-card-section class="row items-center q-pb-none usp-dialog__header">
        <q-icon name="send" size="20px" color="indigo-7" class="q-mr-sm" />
        <div class="text-h6">Отправка в УСП</div>
        <q-space />
        <q-btn
          v-if="data.jsonContent"
          icon="content_copy" flat round dense
          @click="$emit('copy-json')"
        >
          <q-tooltip>Скопировать JSON</q-tooltip>
        </q-btn>
        <q-btn icon="close" flat round dense v-close-popup />
      </q-card-section>
      <q-separator />

      <!-- Тело -->
      <q-card-section class="usp-dialog__body">

        <!-- Загрузка -->
        <div v-if="data.loadingData" class="usp-loading">
          <q-spinner color="indigo-7" size="32px" />
          <span>Загрузка данных...</span>
        </div>

        <!-- Нет сохранённых данных -->
        <div v-else-if="!data.savedRows.length" class="usp-empty-state">
          <q-icon name="info" size="40px" color="grey-5" />
          <div>Нет сохранённых данных за выбранный период</div>
          <div class="usp-empty-hint">Сначала введите данные и нажмите «Сохранить»</div>
        </div>

        <!-- Основной контент -->
        <template v-else>
          <div class="usp-layout">

            <!-- Левая колонка: список работ -->
            <div class="usp-works-panel">
              <div class="usp-works-header">
                <span>Работы ({{ data.workGroups.length }})</span>
                <q-btn
                  flat dense no-caps size="sm" color="indigo-7"
                  label="Все"
                  @click="uspSelectAll"
                />
                <q-btn
                  flat dense no-caps size="sm" color="grey-6"
                  label="Снять"
                  @click="data.stornoSelected = []"
                />
              </div>

              <div class="usp-works-list">
                <div
                  v-for="grp in data.workGroups"
                  :key="grp.usp_work_guid"
                  class="usp-work-row"
                  :class="{
                    'usp-work-row--sent':       grp.is_sent,
                    'usp-work-row--multi-date':  grp.dateCount > 1 && !grp.is_sent,
                  }"
                >
                  <q-checkbox
                    :val="grp.usp_work_guid"
                    v-model="data.stornoSelected"
                    color="deep-orange-7"
                    dense
                    class="usp-work-check"
                  />
                  <div class="usp-work-info">
                    <div class="usp-work-name">{{ grp.work_name }}</div>
                    <div class="usp-work-meta">
                      <q-badge
                        v-if="grp.is_sent"
                        color="green-7" outline
                        label="Отправлено"
                        class="q-mr-xs"
                      />
                      <q-badge
                        v-if="grp.dateCount > 1"
                        color="orange-7" outline
                        :label="`${grp.dateCount} дат`"
                        class="q-mr-xs"
                      />
                      <span class="usp-work-sum">
                        Σ&nbsp;{{ grp.totalValue }}
                        <span v-if="grp.floorCount > 1" class="usp-work-floors">
                          ({{ grp.floorCount }} эт.)
                        </span>
                      </span>
                      <span class="usp-work-guid">{{ grp.usp_work_guid }}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Подсказка -->
              <div class="usp-storno-hint" v-if="data.stornoSelected.length">
                <q-icon name="info" size="14px" color="deep-orange-7" />
                Отмеченные {{ data.stornoSelected.length }} раб. войдут в JSON со значением 0
              </div>

              <!-- Кнопка -->
              <q-btn
                label="Отправить в УСП"
                icon="send"
                color="indigo-7" unelevated no-caps
                class="q-mt-sm"
                :loading="data.loading"
                @click="$emit('build-json')"
              />
            </div>

            <!-- Правая колонка: JSON -->
            <div class="usp-json-panel" v-if="data.jsonContent">
              <div class="usp-json-header">
                <span>JSON для УСП</span>
                <q-btn flat dense no-caps size="sm" icon="content_copy" label="Копировать" @click="$emit('copy-json')" />
              </div>
              <pre class="usp-pre">{{ data.jsonContent }}</pre>
            </div>
            <div class="usp-json-panel usp-json-panel--empty" v-else>
              <template v-if="data.loading">
                <q-spinner-dots size="3em" color="indigo-7" />
                <div style="color:#999; font-size:13px;">Построение JSON…</div>
              </template>
              <template v-else>
                <q-icon name="code" size="48px" color="grey-4" />
                <div style="color:#bbb; font-size:13px;">JSON появится здесь</div>
              </template>
            </div>

          </div>
        </template>

      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'PpmUspDialog',
  props: {
    modelValue: Boolean,
    data: Object,
  },
  emits: ['update:modelValue', 'build-json', 'copy-json'],
  methods: {
    uspSelectAll() {
      this.data.stornoSelected = this.data.workGroups.map((g) => g.usp_work_guid);
    },
  },
};
</script>
